import { useEffect, useState } from 'react';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js";

export default function ContextSelector({contextOptions, setContextArray, isFetching, setIsFetching, simulationData, hbx_functions }) {
    const [schemaValues, setSchemaValues] = useState({ context: [{ transaction: "select" }] });
    
    let previousData = null

    const updateFormValues = () => {
        setIsFetching(true);
        if (simulationData?.length > 0) {
            const newSchemaValues = [];
            simulationData.forEach((tr) => {
                newSchemaValues.push({ key: tr.key, type: tr.type, value: tr.value });
            });
            setSchemaValues({ context: newSchemaValues });
        }else{
            setSchemaValues({ context: [{ transaction: "select" }] });
        }
        setIsFetching(false);
    }

    useEffect(() => {
        updateFormValues();
    }, [simulationData]);


    let options = {
        form_name_root: "context",
        show_errors: "never",
        disable_collapse: true,
        disable_edit_json: true,
        disable_properties: true,
        remove_button_labels: true,
        input_width: '100px',
        disable_array_delete_all_rows: true,
        disable_array_reorder: true,
    }

    const schema = {
        type: "object",
        no_additional_properties: true,
        properties: {
            context: {
                type: "array",
                format: "table",
                items: {
                    type: "object",
                    title: "Context",
                    properties: {
                        key: {
                            type: "string",
                            title: "Key",
                        },
                        type: {
                            type: "string",
                            enumSource: [{
                                source: [...contextOptions],
                                title: "{{item.title}}",
                                value: "{{item.value}}"
                            }],
                            title: "Type",
                        },
                        value: {
                            type: "string",
                            title: "Value",
                        },

                    },
                },
                default: []
            }
        }
    };

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const onChangeJsonEditor = (data) => {


        const elementToDisable = document.querySelectorAll('.card-title');
        if (elementToDisable) {
            elementToDisable.forEach(element => {
                element.style.display = 'none';
            });
        }

        autoFillRandomFunctionArguments(data)
        previousData = data 

    }


    /** Change the value fields based on the type change in case hbx_functions* are selected */
    const autoFillRandomFunctionArguments = (data) => {

        // console.log('textBox changed')
        // console.log('textBox prevdata', previousData)

        if(previousData == null)
            return false

        data.context.forEach( (ctx,index) => {
            
            // console.log('textBox ctx', ctx)
            let prevCtx = previousData.context.find( cx => cx.key == ctx.key )

            // console.log('textBox preCtx', prevCtx)

            if(prevCtx === undefined)
                return;

            // console.log('textBox equal', prevCtx.type, ctx.type)
            if(ctx.type == prevCtx.type)
                return; 

            let textBox = document.getElementById(`context[context][${index}][value]`)

            if(textBox == null)
                return;

            // console.log({textBox},'dom')
            let selectedFunction = hbx_functions.find( option => option.function_name == ctx.type)
            
            if(selectedFunction == null) 
                textBox.value = ''
            else
                textBox.value = JSON.stringify(selectedFunction.arguments)
            ctx.value = textBox.value
        })   
        setContextArray(data?.context)  
    }

    return (
        <>
            {isFetching ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                :
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="json_table_editor" />
            }
        </>
    )




}
